export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "fraud_suspicion_badge": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fraude suspectée"])},
        "assignee_column": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assigné"])}
      },
      "en": {
        "fraud_suspicion_badge": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suspected fraud"])},
        "assignee_column": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assignee"])}
      }
    }
  })
}
